module.exports = __webpack_public_path__ + "files/2e00cbc95268be677f941f276267ab11.svg";